// src/App.jsx - ACTUALIZADO CON TOASTER
import { useState, useEffect } from "react";
import { Toaster } from 'react-hot-toast';
import Login from "./pages/Login";
import Register from "./pages/Register"; // ⭐ NUEVO
import Panel from "./pages/Panel";
import AdminPanel from "./pages/AdminPanel";
import Verificar from "./pages/Verificar";
import TenantSelector from "./components/TenantSelector";
import { Loading } from "./components/shared/Loading";
import { ErrorMessage } from "./components/shared/ErrorMessage";
import { ThemeContext } from "./utils/theme";
import { applyThemeToDocument } from "./utils/theme";
import { detectTenantFromSubdomain, setStoredTenantId } from "./utils/tenant.js";
import { getTenantConfig } from "./services/api";
import { TenantProvider } from "./context/TenantContext";


export default function App() {
  if (window.location.pathname === "/verificar") {
    return <Verificar />;
  }
  return <MainApp />;
}

function MainApp() {
  const [cliente, setCliente] = useState(null);
  const [isStaff, setIsStaff] = useState(false);
  const [tenantConfig, setTenantConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showRegister, setShowRegister] = useState(false); // ⭐ NUEVO

  // Cargar configuración del tenant al iniciar
  useEffect(() => {
    async function loadTenantConfig() {
      try {
        setLoading(true);
        
        const detectedTenant = detectTenantFromSubdomain();
        if (detectedTenant) {
          setStoredTenantId(detectedTenant);
        }
        
        const config = await getTenantConfig();
        setTenantConfig(config);
        applyThemeToDocument(config);
        setError(null);
      } catch (err) {
        console.error("Error cargando configuración del tenant:", err);
        setError("No se pudo cargar la configuración del gimnasio");
      } finally {
        setLoading(false);
      }
    }
    
    loadTenantConfig();
  }, []);

  // Verificar sesión activa después de cargar el tenant
  useEffect(() => {
    if (!tenantConfig) return;
    
    const access = localStorage.getItem("access");
    const userId = localStorage.getItem("userId");
    const staffStatus = localStorage.getItem("isStaff") === "true";
    
    if (access && userId) {
      setCliente({
        id: userId,
        access: access
      });
      setIsStaff(staffStatus);
    }
  }, [tenantConfig]);

  const handleLogin = (loggedUser) => {
    setCliente(loggedUser);
    setIsStaff(loggedUser.is_staff || false);
    
    localStorage.setItem("access", loggedUser.access);
    localStorage.setItem("refresh", loggedUser.refresh);
    localStorage.setItem("userId", loggedUser.id);
    localStorage.setItem("isStaff", loggedUser.is_staff ? "true" : "false");
  };

  const handleLogout = () => {
    setCliente(null);
    setIsStaff(false);
    localStorage.removeItem("access");
    localStorage.removeItem("userId");
    localStorage.removeItem("isStaff");
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center">
        <Loading message="Cargando configuración..." />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-red-900 flex items-center justify-center p-4">
        <div className="max-w-md">
          <ErrorMessage 
            message={error}
            onRetry={() => window.location.reload()}
          />
        </div>
      </div>
    );
  }

  if (!tenantConfig) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center">
        <div className="text-white text-center">
          <p className="text-xl mb-4">No se pudo identificar el gimnasio</p>
          <p className="text-slate-400">Verifica la URL o contacta al soporte</p>
        </div>
      </div>
    );
  }

  return (
    <TenantProvider tenant={tenantConfig}>
    <ThemeContext.Provider value={tenantConfig}>
     
      <Toaster
        position="top-center"
        reverseOrder={false}
        gutter={8}
        toastOptions={{
          // Estilos por defecto
          duration: 4000,
          style: {
            background: '#1e293b',
            color: '#fff',
            border: '1px solid #334155',
            borderRadius: '12px',
            padding: '16px',
            fontSize: '14px',
            fontWeight: '500',
          },
          // Estilos para éxito
          success: {
            duration: 3000,
            iconTheme: {
              primary: tenantConfig?.color_primario || '#10b981',
              secondary: '#fff',
            },
            style: {
              border: `1px solid ${tenantConfig?.color_primario || '#10b981'}40`,
            },
          },
          // Estilos para error
          error: {
            duration: 5000,
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
            style: {
              border: '1px solid #ef444440',
            },
          },
          // Estilos para loading
          loading: {
            iconTheme: {
              primary: tenantConfig?.color_primario || '#3b82f6',
              secondary: '#fff',
            },
          },
        }}
      />

      {!cliente ? (
        <>
          {showRegister ? (
            <Register 
              onSuccess={() => setShowRegister(false)}
              onBackToLogin={() => setShowRegister(false)}
            />
          ) : (
            <Login 
              onLogin={handleLogin} 
              onGoToRegister={() => setShowRegister(true)}
            />
          )}
          <TenantSelector currentTenant={tenantConfig} />
        </>
      ) : isStaff ? (
        <>
          <AdminPanel onLogout={handleLogout}  />
          <TenantSelector currentTenant={tenantConfig} />
        </>
      ) : (
        <>
          <Panel cliente={cliente} onLogout={handleLogout} />
          <TenantSelector currentTenant={tenantConfig} />
        </>
      )}
    </ThemeContext.Provider>
    </TenantProvider>
  );
}